import { render, staticRenderFns } from "./PurimStudents.vue?vue&type=template&id=1fee8928&"
import script from "./PurimStudents.vue?vue&type=script&lang=js&"
export * from "./PurimStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports